import React from 'react';
import SettingsApolloProvider from './clients/SettingsApolloProvider';
import Page from './components/Page';
import { AccessControllerProvider } from './controllers/AccessController';
import { ClientIdControllerProvider } from './controllers/ClientIdController';
import { ErrorControllerProvider } from './controllers/ErrorController';
import { MidControllerProvider } from './controllers/MidController';
import { PluginControllerProvider } from './controllers/PluginController';
import { ApiKeyProvider } from './controllers/useApiKey';
export default function BoostPluginPage() {
    return (React.createElement(ErrorControllerProvider, null,
        React.createElement(PluginControllerProvider, null,
            React.createElement(MidControllerProvider, null,
                React.createElement(SettingsApolloProvider, null,
                    React.createElement(AccessControllerProvider, null,
                        React.createElement(ApiKeyProvider, null,
                            React.createElement(ClientIdControllerProvider, null,
                                React.createElement(Page, null)))))))));
}
